/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
	type BaseResponse,
	BaseResponseFromJSON,
	BaseResponseToJSON,
} from '../models/BaseResponse';

export interface ApiV1ImageGetRequest {
	caseId: string;
	imageId: string;
}

export interface ApiV1ImageThumbnailGetRequest {
	caseId: string;
	imageId: string;
	width: number;
	height: number;
}

export interface ApiV1LogoAnyGetRequest {
	caseId?: string;
	customerId?: string;
}

/**
 *
 */
export class ImageApi extends runtime.BaseAPI {
	/**
	 * Creates request options for apiV1ImageGet without sending the request
	 */
	async apiV1ImageGetRequestOpts(
		requestParameters: ApiV1ImageGetRequest
	): Promise<runtime.RequestOpts> {
		if (requestParameters['caseId'] == null) {
			throw new runtime.RequiredError(
				'caseId',
				'Required parameter "caseId" was null or undefined when calling apiV1ImageGet().'
			);
		}

		if (requestParameters['imageId'] == null) {
			throw new runtime.RequiredError(
				'imageId',
				'Required parameter "imageId" was null or undefined when calling apiV1ImageGet().'
			);
		}

		const queryParameters: any = {};

		if (requestParameters['caseId'] != null) {
			queryParameters['caseId'] = requestParameters['caseId'];
		}

		if (requestParameters['imageId'] != null) {
			queryParameters['imageId'] = requestParameters['imageId'];
		}

		const headerParameters: runtime.HTTPHeaders = {};

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken('Bearer', []);
		}

		let urlPath = `/api/v1/image`;

		return {
			path: urlPath,
			method: 'GET',
			headers: headerParameters,
			query: queryParameters,
		};
	}

	/**
	 */
	async apiV1ImageGetRaw(
		requestParameters: ApiV1ImageGetRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>> {
		const requestOptions = await this.apiV1ImageGetRequestOpts(requestParameters);
		const response = await this.request(requestOptions, initOverrides);

		return new runtime.VoidApiResponse(response);
	}

	/**
	 */
	async apiV1ImageGet(
		requestParameters: ApiV1ImageGetRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void> {
		await this.apiV1ImageGetRaw(requestParameters, initOverrides);
	}

	/**
	 * Creates request options for apiV1ImageThumbnailGet without sending the request
	 */
	async apiV1ImageThumbnailGetRequestOpts(
		requestParameters: ApiV1ImageThumbnailGetRequest
	): Promise<runtime.RequestOpts> {
		if (requestParameters['caseId'] == null) {
			throw new runtime.RequiredError(
				'caseId',
				'Required parameter "caseId" was null or undefined when calling apiV1ImageThumbnailGet().'
			);
		}

		if (requestParameters['imageId'] == null) {
			throw new runtime.RequiredError(
				'imageId',
				'Required parameter "imageId" was null or undefined when calling apiV1ImageThumbnailGet().'
			);
		}

		if (requestParameters['width'] == null) {
			throw new runtime.RequiredError(
				'width',
				'Required parameter "width" was null or undefined when calling apiV1ImageThumbnailGet().'
			);
		}

		if (requestParameters['height'] == null) {
			throw new runtime.RequiredError(
				'height',
				'Required parameter "height" was null or undefined when calling apiV1ImageThumbnailGet().'
			);
		}

		const queryParameters: any = {};

		if (requestParameters['caseId'] != null) {
			queryParameters['caseId'] = requestParameters['caseId'];
		}

		if (requestParameters['imageId'] != null) {
			queryParameters['imageId'] = requestParameters['imageId'];
		}

		if (requestParameters['width'] != null) {
			queryParameters['width'] = requestParameters['width'];
		}

		if (requestParameters['height'] != null) {
			queryParameters['height'] = requestParameters['height'];
		}

		const headerParameters: runtime.HTTPHeaders = {};

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken('Bearer', []);
		}

		let urlPath = `/api/v1/image/thumbnail`;

		return {
			path: urlPath,
			method: 'GET',
			headers: headerParameters,
			query: queryParameters,
		};
	}

	/**
	 */
	async apiV1ImageThumbnailGetRaw(
		requestParameters: ApiV1ImageThumbnailGetRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>> {
		const requestOptions = await this.apiV1ImageThumbnailGetRequestOpts(requestParameters);
		const response = await this.request(requestOptions, initOverrides);

		return new runtime.VoidApiResponse(response);
	}

	/**
	 */
	async apiV1ImageThumbnailGet(
		requestParameters: ApiV1ImageThumbnailGetRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void> {
		await this.apiV1ImageThumbnailGetRaw(requestParameters, initOverrides);
	}

	/**
	 * Creates request options for apiV1LogoAnyGet without sending the request
	 */
	async apiV1LogoAnyGetRequestOpts(
		requestParameters: ApiV1LogoAnyGetRequest
	): Promise<runtime.RequestOpts> {
		const queryParameters: any = {};

		if (requestParameters['caseId'] != null) {
			queryParameters['caseId'] = requestParameters['caseId'];
		}

		if (requestParameters['customerId'] != null) {
			queryParameters['customerId'] = requestParameters['customerId'];
		}

		const headerParameters: runtime.HTTPHeaders = {};

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken('Bearer', []);
		}

		let urlPath = `/api/v1/logo/any`;

		return {
			path: urlPath,
			method: 'GET',
			headers: headerParameters,
			query: queryParameters,
		};
	}

	/**
	 */
	async apiV1LogoAnyGetRaw(
		requestParameters: ApiV1LogoAnyGetRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>> {
		const requestOptions = await this.apiV1LogoAnyGetRequestOpts(requestParameters);
		const response = await this.request(requestOptions, initOverrides);

		return new runtime.VoidApiResponse(response);
	}

	/**
	 */
	async apiV1LogoAnyGet(
		requestParameters: ApiV1LogoAnyGetRequest = {},
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void> {
		await this.apiV1LogoAnyGetRaw(requestParameters, initOverrides);
	}
}
